import {computed, Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
    // Счетчик активных запросов
    private activeRequestsCount = signal(0);

    // Вычисляемый сигнал: true, если есть хотя бы один активный запрос
    public isLoading = computed(() => this.activeRequestsCount() > 0);

    show(): void {
        this.activeRequestsCount.update(count => count + 1);
    }

    hide(): void {
        this.activeRequestsCount.update(count => Math.max(0, count - 1));
    }
}
